import type { PublicTarifCategoryDisplay } from '../../utils/academiaTarifs';

type Props = {
  pricingCategories: PublicTarifCategoryDisplay[];
  priceFrom: string | null;
  pricingLoading?: boolean;
  inscriptionsOuvertes: boolean;
  onSubscribe: () => void;
};

function CheckIcon() {
  return (
    <svg
      className="pfd-tarifs-business__check-icon"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden
    >
      <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
    </svg>
  );
}

export default function PublicFiliereTarifsBusinessCard({
  pricingCategories,
  priceFrom,
  pricingLoading,
  inscriptionsOuvertes,
  onSubscribe,
}: Props) {
  const displayPrice = priceFrom ?? (pricingLoading ? '…' : '—');

  return (
    <article
      className={`pfd-tarifs-business pricing-card scroll-mt-24 ${pricingLoading ? 'opacity-70' : ''}`}
      id="tarifs"
      data-purpose="business-plan"
    >
      <div className="pfd-tarifs-business__main">
        <div>
          <h3 className="pfd-tarifs-business__title">Tarifs d&apos;inscription</h3>
          <p className="pfd-tarifs-business__desc">
            Grille des frais d&apos;inscription, de participation et de brevet.
            Les montants varient selon votre catégorie d&apos;apprenant.
          </p>
        </div>
        <div>
          <div className="pfd-tarifs-business__price-row">
            <span className="pfd-tarifs-business__price">{displayPrice}</span>
            <span className="pfd-tarifs-business__price-unit">/ inscription</span>
          </div>
          {inscriptionsOuvertes ? (
            <button
              type="button"
              className="pfd-tarifs-business__cta"
              data-purpose="cta-button"
              onClick={onSubscribe}
            >
              Souscrire
            </button>
          ) : (
            <span className="pfd-tarifs-business__cta pfd-tarifs-business__cta--disabled">
              Inscriptions fermées
            </span>
          )}
        </div>
      </div>

      <div className="pfd-tarifs-business__features" data-purpose="features-list">
        <span className="pfd-tarifs-business__features-label">Comprend :</span>
        <ul className="pfd-tarifs-business__features-list">
          {pricingCategories.length === 0 ? (
            <li className="pfd-tarifs-business__feature">
              <CheckIcon />
              <span className="pfd-tarifs-business__feature-text">Tarifs en cours de publication</span>
            </li>
          ) : (
            pricingCategories.map((row) => (
              <li key={row.id} className="pfd-tarifs-business__feature">
                <CheckIcon />
                <span className="pfd-tarifs-business__feature-text">
                  <strong className="pfd-tarifs-business__feature-cat">{row.label}</strong>
                  {' — '}
                  Inscription {row.inscription}, participation {row.participation}, brevet {row.brevet}
                </span>
              </li>
            ))
          )}
        </ul>
      </div>
    </article>
  );
}
